/**
 * Finds a value in an object by searching for a team ID within the keys
 * @param obj Object with keys like "teamId_14112_217"
 * @param clientId Client ID to search for (e.g. 14112)
 * @returns The value associated with the found key, or undefined if not found
 */
const findValueByClientId = (obj: Record<string, string>, clientId: number): string | undefined => {
  const foundKey = Object.keys(obj).find(objKey => {
    const parts = objKey.split('_');
    return parts.length >= 2 && parts[0] === 'teamId' && Number(parts[1]) === clientId;
  });
  return foundKey ? obj[foundKey] : undefined;
};

export default findValueByClientId;
